<template>
  <div class="room-select">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="树形选择" name="1">
        <el-scrollbar ref="scroll" wrap-class="room-wrap" view-class="room-view" noresize>
          <el-tree :props="props" lazy :load="loadNode" @node-click="selectRoom"></el-tree>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="模糊查询" name="2">
        <div class="room-fuzzy">
          <el-autocomplete
            v-model="keywords"
            :trigger-on-focus="false"
            value-key="roomName"
            placeholder="请至少输入3个字符"
            :fetch-suggestions="queryRoom"
            style="width: 400px;"
            @select="selectRoom2"
          ></el-autocomplete>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { loadRoomFuzzy, loadRoomTree1, loadRoomTree2 } from '@/api/common/room-select';
export default {
  name: 'RoomSelect',
  props: ['communityGroup'],
  data() {
    return {
      activeTab: '1',
      keywords: '',
      props: {
        label: 'roomName',
        isLeaf: 'isLeaf',
      },
    };
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        loadRoomTree1({communityGroup:this.communityGroup||''}).then(({ data }) => {
          return resolve(data);
        });
      }
      if (node.level >= 1) {
        loadRoomTree2({ id: node.data.id }).then(({ data }) => {
          return resolve(data);
        });
      }
    },
    selectRoom(data) {
      data.roomId = data.objectType === 6 ? data.id : '';
      this.$emit('select', data);
    },
    queryRoom(qs, cb) {
      if (qs.length < 3) {
        cb();
        return;
      }
      loadRoomFuzzy({ searchContent: qs }).then(({ data }) => {
        cb(data);
      });
    },
    selectRoom2(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.room-select {
  height: 500px;
  .room-wrap {
    height: 450px;
  }
  .room-view {
    height: 194px;
  }
  .room-fuzzy {
    margin-top: 16px;
    text-align: center;
  }
}
</style>
